import { matchPath } from "react-router-dom";

/**
 * React Router v5 helper for sidebar active state (supports activeMatchPaths on menu items).
 */
const RouteMatch = ({ path, exact, activeMatchPaths, children, location }) => {
  const pathname = location?.pathname ?? window.location.pathname;
  const paths =
    Array.isArray(activeMatchPaths) && activeMatchPaths.length > 0
      ? activeMatchPaths
      : [path];
  // Strict per-pattern match when activeMatchPaths is set; otherwise default exact for single paths.
  const useExact =
    Array.isArray(activeMatchPaths) && activeMatchPaths.length > 0
      ? true
      : exact === true;
  const match = paths.some((p) => p && matchPath(pathname, { path: p, exact: useExact }) != null);
  return children({ match });
};

export default RouteMatch;
